import React, { useState, useEffect } from 'react';
import { ToastContentProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSwitchStateFromDB } from '../../utils/services/idbService';

const OnlineToast: React.FC<ToastContentProps> = () => {
  const [switchState, setSwitchState] = useState(null);

  useEffect(() => {
    const loadSwitchState = async () => {
      const username = localStorage.getItem('currentUser') || 'unknown';
      const newState = await getSwitchStateFromDB('user_switch_state', username);
      setSwitchState(newState);
    };

    loadSwitchState();
  }, []);

// 2024/8/8: Disabled based on the Sync Tab is hidden
//   const message = switchState
//     ? 'Syncing any changes you have made. Online features now available.'
//     : 'Your test results will save locally. Other features are limited..';
const message = 'Syncing any changes you have made. Online features now available.'

    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center',
            justifyContent: 'flex-start', 
            backgroundColor: '#EDF7ED',
            borderRadius: '4px !important',
            width: '100%',
        }}>
            <img src="/assets/icons/online.svg" alt="Online" style={{ marginRight: '12px', marginBottom: '42px' }} />
            <div style={{ textAlign: 'left' }}> 
                <strong style={{ 
                    fontSize: '16px', 
                    color: '#345035',
                    fontFamily: 'Jost'
                }}>Online Mode</strong>
                <p style={{ 
                    fontSize: '14px', 
                    color: '#345035',
                    fontFamily: 'Jost'
                }}>{message}</p>
            </div>
        </div>
    );
};

export default OnlineToast;
